import React, {useEffect, useState} from 'react'
import {Box, Button, MenuItem, Typography} from "@mui/material";
import {useAppDispatch, useAppSelector} from "@store/hooks";
import {appUserProfileSelector, getProfileAction} from "@store/slices/app.slice";
import {getMyTokensAction} from "@store/slices/token.slice";
import {getWalletAction, saveWalletAction, updateSelectedAddress, walletSelector} from "@store/slices/wallet.slice";
import {WalletParam, WalletTags} from "@interfaces/wallet";
import {ethers} from "ethers";
import LogoutIcon from '@mui/icons-material/Logout';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faEthereum, faGoogleWallet} from '@fortawesome/free-brands-svg-icons'
import {faWallet, faPlus} from '@fortawesome/free-solid-svg-icons'
import {walletService} from "@services/wallet.service";
import {toasterService} from "@services/toaster.service";


const Wallet = ({type, isConnected}: WalletParam) => {

    const userProfile = useAppSelector(appUserProfileSelector);
    const userWallet = useAppSelector(walletSelector);
    const dispatch = useAppDispatch();

    const [errorMessage, setErrorMessage] = useState(null);
    const [walletText, setWalletText] = useState('Connect Wallet');
    const [disabled, setDisabled] = useState(false);
    const [tagType, setTagType] = useState(0); // Options
    const [walletAddress, setWalletAddress] = useState(''); // Options
    const [walletBalance, setWalletBalance] = useState('0'); // Options

    useEffect(() => {
        console.dir(userWallet)
        setTagType(type);

        dispatch(getProfileAction())

        if (userProfile.id) {
            dispatch(getWalletAction({id: userProfile.id}))

            const selectedAddress = userWallet.selectedAddress;
            console.log("Account", selectedAddress);

            //If MetaMask is connected, use that address
            if(selectedAddress?.length > 8 && selectedAddress?.startsWith("0x")) {
                const trimmedAddress = trimAddress(selectedAddress)
                setWalletAddress(selectedAddress);
                if (isConnected) {
                    isConnected();
                }

                setWalletText(trimmedAddress);

                dispatch(updateSelectedAddress(selectedAddress))
                /*if(!userWallet.address.includes(account)) {
                    console.log('SAVING!')
                    dispatch(saveWalletAction({id: userProfile.id, address: account} ))
                }*/
                saveWalletAddress(userProfile.id, selectedAddress);
            } else {
                /*dispatch(updateSelectedAddress(''));
                setWalletAddress('');*/
            }
        }
    }, [])

    const validateAddress = async (address: string) => {
        //TODO: Randomize unique message?
        const uniqueMsg = Date.now();
        const message = `Hi there from Stakes! Sign this message to prove you have access to this wallet and we’ll log you in. This won’t cost you any Ether.
 Here’s a unique message ID for this session: ${uniqueMsg}`;
        const provider = new ethers.providers.Web3Provider(window.ethereum as any);
        const signer = provider.getSigner();
        const signature = await signer.signMessage(message);

        try {
            const signerAddr = ethers.utils.verifyMessage(message, signature)
            return signerAddr.toLowerCase() === address;
        } catch (err) {
            console.log(err);
            return false;
        }

    }

    const connectWallet = async () => {
        if(!userWallet.selectedAddress || userWallet.selectedAddress.length === 0) {
            // You need to await for user response on the metamask popup dialog
            const accounts = await window.ethereum.request<string[]>({method: 'eth_requestAccounts'});
            if (accounts) {
                const selectedAddress = accounts[0];

                if (selectedAddress) {
                    const verified = await validateAddress(selectedAddress);

                    if (!verified) {
                        //TODO: add red flag to user
                        toasterService.success('Signing address does not match connecting address');
                    }
                    else {
                        toasterService.success('Verified address and successfully logged in');
                        const trimmedAddress = trimAddress(selectedAddress)
                        // addWalletText("Wallet: ", address);
                        setWalletText(trimmedAddress);
                        setWalletAddress(selectedAddress);
                        dispatch(updateSelectedAddress(selectedAddress));

                        if (isConnected) {
                            isConnected();
                        }
                        saveWalletAddress(userProfile.id, selectedAddress);
                    }
                }
            }
        }
    }

    const disconnectWallet = async () => {
        dispatch(updateSelectedAddress(''));
        setWalletAddress('');
        setWalletText('Connect Wallet')
    }

    /*const onSendOTP = () => {
        dispatch(sendOTPAction(verificationData.email))
    }*/

    const addWalletText = (address: string, prefix?: string) => {
        setWalletText(`${prefix}${address}...`);
    }

    const getBalance = async (address: string) => {
        const wei = await walletService.getAccountBalance(address);
        if (wei && wei > 0) {
            setWalletBalance(ethers.utils.formatEther(wei));
        }
    }

    const trimAddress = (address: string) => {
        return address.substring(0, 5) + "..." + address.substring(37);
    }

    /**
     * Check to see if the wallet address has already been connected by the user. If not, save
     * @param id
     * @param address
     */
    const saveWalletAddress = (id: string, address: string) => {
        // console.log("save wallet")
        // console.log(userWallet)
        if(!userWallet.address.includes(address)) {
            dispatch(saveWalletAction({id, address} ))
        }
    }

    if (tagType === WalletTags.menu) {
        const hasWallet = walletAddress.length > 0;
        return (
            <>
                {!hasWallet && (
                    // <MenuItem disabled={disabled} onClick={connectWallet}>
                    <MenuItem disabled={disabled} onClick={connectWallet}>

                        <AccountBalanceWalletIcon fontSize="small" />
                        <span>&nbsp; {walletText}</span>
                    </MenuItem>
                )}

                {hasWallet && (
                    <MenuItem onClick={disconnectWallet}>
                        <span>{walletText} &nbsp; </span>
                        <LogoutIcon fontSize="small" />
                    </MenuItem>
                )}
            </>
        );
        /*{!hasWallet && (
                    <MenuItem disabled={disabled} onClick={connectWallet}> <FontAwesomeIcon icon={faWallet}/>
                        <span>{walletText}</span> </MenuItem>
                )}*/

    } else if (tagType === WalletTags.checkout) {
        const hasWallet = walletAddress.length > 0;
        // const address1 = walletAddress.substring(0, 7);
        // const address2 = walletAddress.substr(walletAddress.length - 5);
        return (
            <div>
                {!hasWallet && (
                    <Button onClick={connectWallet}>Connect Wallet</Button>)}
                {hasWallet && getBalance(walletAddress) && (
                    <Box className="flex-align-center">
                        <FontAwesomeIcon icon={faEthereum}/>
                        <Box ml={2}>
                            <Box display="flex" flexDirection="column">
                                {/*<Typography variant="caption">Address: {address1} ... {address2}</Typography>*/}
                                <Typography variant="caption">Address: {trimAddress(walletAddress)}</Typography>
                                <Typography variant="caption">Balance: {walletBalance}</Typography>
                            </Box>
                        </Box>
                    </Box>
                )
                }

            </div>
        );
    } else {
        return (<div/>);
    }
}


export default Wallet;

/*
const initialize = () =>
{
    //Basic Actions Section
    const onboardButton = document.getElementById('connectButton');
    const getAccountsButton = document.getElementById('getAccounts');
    const getAccountsResult = document.getElementById('getAccountsResult');

    const onClickConnect = async () => {
        try {
            // Will open the MetaMask UI
            // You should disable this button while the request is pending!
            await ethereum.request({method: 'eth_requestAccounts'});
        } catch (error) {
            console.error(error);
        }
    };

    const MetaMaskClientCheck = () => {
        //Now we check to see if Metmask is installed
        if (!isMetaMaskInstalled()) {
            //If it isn't installed we ask the user to click to install it
            onboardButton.innerText = 'Click here to install MetaMask!';
            //When the button is clicked we call th is function
            onboardButton.onclick = onClickInstall;
            //The button is now disabled
            onboardButton.disabled = false;
        } else {
            //If MetaMask is installed we ask the user to connect to their wallet
            onboardButton.innerText = 'Connect';
            //When the button is clicked we call this function to connect the users MetaMask Wallet
            onboardButton.onclick = onClickConnect;
            //The button is now disabled
            onboardButton.disabled = false;
        }
    };

//Eth_Accounts-getAccountsButton
    getAccountsButton.addEventListener('click', async () => {
        //we use eth_accounts because it returns a list of addresses owned by us.
        const accounts = await ethereum.request({method: 'eth_accounts'});
        //We take the first address in the array of addresses and display it
        getAccountsResult.innerHTML = accounts[0] || 'Not able to get accounts';
    });

    MetaMaskClientCheck();
}
;*/
